import { api } from './base';

import { MutationArg, Pageable } from 'v2/types';
import { DomainModel } from 'v2/types/DomainModel';
import { SWRKeyPagination, SWRKeyValue } from 'v2/types/swr';

export const domainService = {
  getDomains([_key, page, limit]: SWRKeyPagination): Promise<Pageable<DomainModel>> {
    return api
      .get('v1/admin/domain', { searchParams: { page, limit, sortFields: JSON.stringify({ _id: 'asc' }) } })
      .json();
  },

  createDomain(_key: string, { arg: domainName }: MutationArg<string>): Promise<DomainModel> {
    return api.post('v1/admin/domain', { json: { domainName } }).json();
  },

  activateDomain([_key, id]: SWRKeyValue): Promise<void> {
    return api.patch(`v1/admin/domain/${id}/activate`).json();
  },

  deleteDomain([_key, id]: SWRKeyValue): Promise<void> {
    return api.delete(`v1/admin/domain/${id}`).json();
  },
};
